import { Component, OnInit, Inject, ViewChild, ElementRef } from '@angular/core';
import {  MatAutocompleteSelectedEvent,  MatAutocomplete } from '@angular/material/autocomplete';
import {  MatChipInputEvent } from '@angular/material/chips';
import { MatDialogRef,  MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CompanyUserService } from '../../company-user.service';
import { Observable } from 'rxjs';
import { UntypedFormControl } from '@angular/forms';
import { map, startWith } from 'rxjs/operators';
import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { of } from 'rxjs';

@Component({
  selector: 'app-update-company-in-user-popup',
  templateUrl: './update-company-in-user-popup.html',
  styleUrls: ['./update-company-in-user-popup.css',
  '../../../../admin-dashboard/common-popup/common-popup.css']
})
export class UpdateCompanyInUserPopup {

  companies$ = new Observable();
  emailList = []


  visible = true;
  selectable = true;
  removable = true;
  addOnBlur = true;
  separatorKeysCodes: number[] = [ENTER, COMMA];
  fruitCtrl = new UntypedFormControl();
  filteredFruits: Observable<string[]>;
  fruits: string[] = ['Lemon'];
  allFruits: string[] = ['Apple', 'Lemon', 'Lime', 'Orange', 'Strawberry'];

  @ViewChild('fruitInput',{static:false}) fruitInput: ElementRef<HTMLInputElement>;
  @ViewChild('auto',{static:false}) matAutocomplete: MatAutocomplete;


  constructor(
    public dialogRef: MatDialogRef<UpdateCompanyInUserPopup>,
    @Inject(MAT_DIALOG_DATA) public data, private companyUserService: CompanyUserService) {
    this.emailList = data.companies
   

    this.companies$ = this.companyUserService.getCompanies$().pipe(map(arr => {
     return arr.map(obj => {
        return {
          ...obj,
          active: this.emailList.filter(i =>  i.companyId == obj['companyId']).length > 0
        }
      })
    }));



    this.filteredFruits = this.fruitCtrl.valueChanges.pipe(
      startWith(null),
      map((fruit: string | null) => fruit ? this._filter(fruit) : this.allFruits.slice()));
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  add(event: MatChipInputEvent): void {
    // Add fruit only when MatAutocomplete is not open
    // To make sure this does not conflict with OptionSelected Event
    if (!this.matAutocomplete.isOpen) {
      const input = event.input;
      const value = event.value;

      // Add our fruit
      if ((value || '').trim()) {
        this.emailList.push(value.trim());
      }

      // Reset the input value
      if (input) {
        input.value = '';
      }

      this.fruitCtrl.setValue(null);
    }
  }

  remove(fruit: string): void {
    const index = this.emailList.indexOf(fruit);
    if (index >= 0) {
      this.emailList.splice(index, 1);
      this.companyUserService.updateCompanyToUser(this.data.userId,this.emailList.map(obj=> obj['companyId']))

    }
  }

  selected(event: MatAutocompleteSelectedEvent): void {
    this.emailList.push(event.option.value);
   this.companyUserService.updateCompanyToUser(this.data.userId,this.emailList.map(obj=> obj['companyId']))
    this.fruitInput.nativeElement.value = '';
    this.fruitCtrl.setValue(null);
  }

  private _filter(value: string): string[] {
    const filterValue = value.toLowerCase();

    return this.allFruits.filter(fruit => fruit.toLowerCase().indexOf(filterValue) === 0);
  }
}
